import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

@Injectable()
export class PDFGeneratorService extends ApiService {

    generate (placeholders): Observable<any> {
        return this.postRaw('/wfs-direct/api/session/', {
            request_type: 'GENERATE_ADVERSE',
            data: {
                placeholders
            }
        });
    }

}


// WEBPACK FOOTER //
// ./src/app/shared/services/auto-loans/pdf-generator.service.ts